/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ISocialChannel } from '../social-channel-schema';
import { socialChannelSchema } from '../social-channel-schema';

const addDataSchema = z.object({
  channel: socialChannelSchema,
});

export interface IAddSocialChannelV1Data {
  channel: ISocialChannel;
}

export const addSocialChannelV1ResponseSchema = createApiResponseSchema(
  addDataSchema,
) as z.ZodSchema<IAPI<IAddSocialChannelV1Data>>;

export type IAddSocialChannelV1Response = IAPI<IAddSocialChannelV1Data>;
